import './App.css';
import About from './components/About';
import Contact from './components/Contact';
import MyWorks from './components/MyWorks';
import Profile from './components/Profile';

function App() {
  return (
    <>
      <Profile />
      <About />
      <MyWorks />
      <Contact />
    </>
  );
}

export default App;
